import React from "react";
import styled from "styled-components";
import { spacing16, spacing24 } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-zwfeft-0"
})(["position:relative;z-index:2;display:flex;width:100%;justify-content:space-between;align-items:center;padding:", ";", ";"], spacing16, mediaBreak600w`
    padding: ${spacing24};
    padding-block-end: ${spacing16};
  `);

/**
 * Handles content that goes in the Head Slot.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.start] - First section of header
 * @param {React.ReactNode} [props.end] - Second section of header
 * @returns {React.ReactNode} - The Head component.
 */
const Head = ({
  start,
  end
}) => /*#__PURE__*/_jsxs(Container, {
  children: [start ? start : /*#__PURE__*/_jsx("div", {}), end ? end : /*#__PURE__*/_jsx("div", {})]
});
Head.displayName = "Head";
export default Head;